import { render, staticRenderFns } from "./BillRevenue.vue?vue&type=template&id=8353fd70&scoped=true&"
import script from "./BillRevenue.vue?vue&type=script&lang=js&"
export * from "./BillRevenue.vue?vue&type=script&lang=js&"
import style0 from "./BillRevenue.vue?vue&type=style&index=0&id=8353fd70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8353fd70",
  null
  
)

export default component.exports